import React, { Component } from 'react';
import { connect } from 'react-redux';

import questionActions from '../../actions/questions';
import ResponsesManager from '../questions/responsesManager'
import { FocusPointsInputAndConceptSelectorForm, } from '../../../Shared/index';

class EditFocusPointsContainer extends Component {
  constructor() {
    super();

    this.state = { questionType: 'questions', questionTypeLink: 'questions', actionFile: questionActions }
  }

  getFocusPoint = () => {
    const { questionType } = this.state
    const { match } = this.props
    const { params } = match
    const { focusPointID, questionID } = params
    const focusPoint = this.props[questionType].data[questionID].focusPoints[focusPointID]
    return Object.assign(focusPoint, { id: focusPointID, });
  }

  submitForm = (data, focusPointID) => {
    const { actionFile } = this.state
    const { dispatch, match } = this.props
    const { params } = match
    const { questionID } = params
    delete data.conceptResults.null;
    dispatch(actionFile.submitEditedFocusPoint(questionID, data, focusPointID));
    setTimeout(() => {window.history.back()}, 2000);
  };

  render() {
    const { match, questions } = this.props
    const { params } = match
    const { questionID } = params
    return (
      <div>
        <FocusPointsInputAndConceptSelectorForm
          item={this.getFocusPoint()}
          itemLabel="Focus Point"
          onSubmit={this.submitForm}
          questionID={questionID}
          questions={questions}
          ResponsesManager={ResponsesManager}
          states={true}
        />
      </div>
    );
  }
}

function select(props) {
  return {
    questions: props.questions,
    fillInBlank: props.fillInBlank
  }
}

export default connect(select)(EditFocusPointsContainer);
